var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWindows = function SvgWindows(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.801 12.1461V2.66211C19.156 3.14611 15.543 3.66211 11.865 4.24211V12.2111C15.543 12.1781 19.155 12.1781 22.801 12.1461ZM2.83301 5.59811V12.3081C5.51001 12.3081 8.28501 12.2751 10.962 12.2751V4.46911C8.28501 4.82311 5.51001 5.17911 2.83301 5.59811ZM2.83301 13.0821V19.7921C5.51001 20.1461 8.28501 20.5011 10.962 20.8881V13.1461C8.28501 13.0811 5.51001 13.0821 2.83301 13.0821ZM11.963 13.2101C11.994 15.8561 11.994 18.4361 11.994 21.0501C15.6073 21.5334 19.2203 22.0494 22.833 22.5981V13.2101H11.963Z",
    fill: "white"
  })));
};
export default SvgWindows;